import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ServiceComponent } from './service/service.component';
import { AadharComponent } from './aadhar/aadhar.component';
import { PanComponent } from './pan/pan.component';
import { GstComponent } from './gst/gst.component';
import { DrivingComponent } from './driving/driving.component';
import { PassportComponent } from './passport/passport.component';
import { RcverifyComponent } from './rcverify/rcverify.component';
import { MsmeverifyComponent } from './msmeverify/msmeverify.component';
import { DinverifyComponent } from './dinverify/dinverify.component';
import { CinverifyComponent } from './cinverify/cinverify.component';
import { ContactusComponent } from './contactus/contactus.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { WhitecollarComponent } from './whitecollar/whitecollar.component';
import { BluecollarComponent } from './bluecollar/bluecollar.component';
import { GigworkerComponent } from './gigworker/gigworker.component';
import { RiskmanageComponent } from './riskmanage/riskmanage.component';
import { VendoronboardComponent } from './vendoronboard/vendoronboard.component';
import { DistributoronboardComponent } from './distributoronboard/distributoronboard.component';
import { DueDiligenceComponent } from './due-diligence/due-diligence.component';
import { KycSolutionComponent } from './kyc-solution/kyc-solution.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { RefundpolicyComponent } from './refundpolicy/refundpolicy.component';
import { HomePageComponent } from './home-page/home-page.component';
import { TestComponent } from './test/test.component';
import { WebsiteComponent } from './website/website.component';
import { SignupComponent } from './signup/signup.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';

const routes: Routes = [
  
  
  // { path: '', redirectTo: '/website/home', pathMatch: 'full'},
 

  {
    path: '',
    component: WebsiteComponent,
    children:[
      {
        path: 'home',
        component: HomeComponent,
      },
   
      {
        path:'signUp',
        component:SignupComponent
      },
   
      {
        path:'contactus',
        component:ContactusComponent
      },
      {
        path:'aboutus',
        component:AboutusComponent
      },
   
       {
        path:'disclaimer',
        component:DisclaimerComponent
      },
      {
        path:'termscondition',
        component:TermsConditionComponent
      },
      {
        path:'privacypolicy',
        component:PrivacypolicyComponent
      },
      {
        path:'refundpolicy',
        component:RefundpolicyComponent
      },
     
      {path: '**' , redirectTo: '/home'},

      
    
    ]
  },


   
];





@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
